(function () {
  if (window.__ucuBooted) return;
  window.__ucuBooted = 1;
  // Labels come translated from snippets/uplift-cart-upsell.liquid (data-t-*); English only if missing.
  function T(host, key, fallback) { return host.getAttribute('data-t-' + key) || fallback; }
  function el(t, c) { var e = document.createElement(t); if (c) e.className = c; return e; }
  function closeAllOpts(keep) {
    document.querySelectorAll('#cart-drawer .ucu__opts').forEach(function (o) { if (o !== keep) o.hidden = true; });
  }
  function parseVariants(card) {
    var s = card.querySelector('.ucu__v');
    if (!s) return [];
    try { return JSON.parse(s.textContent); } catch (e) { return []; }
  }
  function avail(vs, oi, val, sel, oc) {
    return vs.some(function (v) {
      if (!v.a) return false;
      if (v.o[oi] !== val) return false;
      for (var k = 0; k < oc; k++) { if (k !== oi && sel[k] && v.o[k] !== sel[k]) return false; }
      return true;
    });
  }
  function match(vs, sel, oc) {
    return vs.filter(function (v) {
      for (var k = 0; k < oc; k++) { if (!sel[k] || v.o[k] !== sel[k]) return false; }
      return true;
    })[0];
  }
  function add(vid, btn) {
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }], sections: ['cart-drawer-section'], sections_url: location.pathname })
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (d.status) { btn.disabled = false; return; }
      var html = d.sections && d.sections['cart-drawer-section'];
      if (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.cart-drawer__inner');
        var live = document.querySelector('#cart-drawer .cart-drawer__inner');
        if (fresh && live) live.replaceWith(fresh);
        else if (window.Shopify && window.Shopify.designMode) console.warn('[uplift-cart-upsell] .cart-drawer__inner morph target missing — Horizon may have renamed the cart drawer.');
      }
      // Header bag count: Horizon's <cart-icon> only listens for its own add-to-cart event,
      // so push the new total to it directly after an upsell add.
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
        document.querySelectorAll('cart-icon').forEach(function (icon) {
          if (typeof icon.renderCartBubble === 'function') icon.renderCartBubble(c.item_count);
        });
      }).catch(function () {});
    }).catch(function () { btn.disabled = false; });
  }
  function wireCard(card) {
    var single = card.getAttribute('data-single') === '1';
    var oc = +card.getAttribute('data-oc') || 0;
    var vs = parseVariants(card);
    var addBtn = card.querySelector('.ucu__add');
    var opts = card.querySelector('.ucu__opts');
    var mid = card.querySelector('.ucu__mid');
    var sel = [null, null, null];
    if (opts) {
      opts.hidden = true;
      if (mid) {
        mid.style.cursor = 'pointer';
        mid.setAttribute('role', 'button');
        mid.setAttribute('tabindex', '0');
        mid.setAttribute('aria-expanded', 'false');
        var toggleOpts = function () {
          if (opts.hidden) { closeAllOpts(opts); opts.hidden = false; mid.setAttribute('aria-expanded', 'true'); }
          else { opts.hidden = true; mid.setAttribute('aria-expanded', 'false'); }
        };
        mid.addEventListener('click', toggleOpts);
        mid.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleOpts(); } });
      }
    }
    function refresh() {
      card.querySelectorAll('.ucu__optrow').forEach(function (row) {
        var oi = +row.getAttribute('data-oi');
        row.querySelectorAll('[data-val]').forEach(function (btn) {
          btn.classList.toggle('off', !avail(vs, oi, btn.getAttribute('data-val'), sel, oc));
        });
      });
      var complete = true;
      for (var k = 0; k < oc; k++) { if (!sel[k]) { complete = false; break; } }
      var v = complete ? match(vs, sel, oc) : null;
      addBtn.classList.toggle('ready', !!(v && v.a));
    }
    card.querySelectorAll('.ucu__optrow').forEach(function (row) {
      var oi = +row.getAttribute('data-oi');
      var pre = row.querySelector('.sel[data-val]');
      if (pre) sel[oi] = pre.getAttribute('data-val');
      row.querySelectorAll('[data-val]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          sel[oi] = btn.getAttribute('data-val');
          row.querySelectorAll('[data-val]').forEach(function (x) { x.classList.toggle('sel', x === btn); });
          refresh();
        });
      });
    });
    addBtn.addEventListener('click', function () {
      if (single) { if (vs[0]) add(vs[0].id, addBtn); return; }
      var complete = true;
      for (var k = 0; k < oc; k++) { if (!sel[k]) { complete = false; break; } }
      var v = complete ? match(vs, sel, oc) : null;
      if (v && v.a) { add(v.id, addBtn); }
      else if (opts) { closeAllOpts(opts); opts.hidden = false; }
    });
    refresh();
  }
  function build(host, cardsContainer) {
    var cards = [].slice.call(cardsContainer.querySelectorAll('.ucu__card'));
    if (!cards.length) { host.hidden = true; return; }
    var head = el('div', 'ucu__head');
    var h = el('p', 'ucu__h'); h.textContent = T(host, 'heading', 'Others also bought'); head.appendChild(h);
    var nav = el('button', 'ucu__nav'); nav.type = 'button'; nav.setAttribute('aria-label', T(host, 'more', 'Show more')); nav.textContent = '›'; head.appendChild(nav);
    host.appendChild(head);
    var track = el('div', 'ucu__track');
    // Cards per page: theme settings "UPLIFT Cart Draw" (defaults 1 on mobile, 2 on desktop). Horizon's mobile breakpoint.
    var mobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    var perPage = +(mobile ? host.getAttribute('data-per-mobile') : host.getAttribute('data-per-desktop')) || (mobile ? 1 : 2);
    for (var i = 0; i < cards.length; i += perPage) {
      var page = el('div', 'ucu__page');
      for (var j = 0; j < perPage; j++) { if (cards[i + j]) page.appendChild(cards[i + j]); }
      track.appendChild(page);
    }
    host.appendChild(track);
    if (cards.length <= perPage) nav.style.display = 'none';
    nav.addEventListener('click', function () {
      var max = track.scrollWidth - track.clientWidth - 4;
      if (track.scrollLeft >= max) { track.scrollTo({ left: 0, behavior: 'smooth' }); }
      else { track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); }
    });
    cards.forEach(wireCard);
    host.hidden = false;
  }
  function fetchRecs(pid, intent) {
    return fetch('/recommendations/products?section_id=uplift-cart-upsell&product_id=' + pid + '&intent=' + intent + '&limit=10')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var cards = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ucu-cards]');
        if (!cards || !cards.querySelector('.ucu__card')) return null;
        // Only top-up cards (no real complementary products)? Try 'related' first, which also gets topped up.
        if (intent === 'complementary' && !cards.querySelector('.ucu__card:not([data-fill])')) return null;
        return cards;
      });
  }
  function ensure() {
    var host = document.querySelector('#cart-drawer [data-uplift-upsell]');
    if (!host) return;
    // Only fetch recommendations once the cart drawer is actually open (not on every page load).
    if (!document.querySelector('#cart-drawer dialog[open]')) return;
    var pid = host.getAttribute('data-product-id');
    if (!pid) { host.hidden = true; return; }
    if (host.getAttribute('data-ucu-pid') === pid && host.querySelector('.ucu__card')) return;
    if (host.getAttribute('data-ucu-busy') === pid) return;
    host.setAttribute('data-ucu-busy', pid);
    // complementary first; fall back to 'related' so the slot is never empty
    fetchRecs(pid, 'complementary')
      .then(function (cards) { return cards || fetchRecs(pid, 'related'); })
      .then(function (cards) {
        host.removeAttribute('data-ucu-busy');
        if (host.getAttribute('data-product-id') !== pid) { ensure(); return; }
        host.innerHTML = '';
        if (cards) {
          host.setAttribute('data-ucu-pid', pid);
          build(host, cards);
        } else {
          host.removeAttribute('data-ucu-pid');
          host.hidden = true;
        }
      })
      .catch(function () { host.removeAttribute('data-ucu-busy'); });
  }
  function boot() {
    ensure();
    document.addEventListener('shopify:section:load', ensure);
    var root = document.getElementById('cart-drawer');
    if (root && window.MutationObserver) {
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(ensure, 60); }).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
    } else {
      document.addEventListener('DOMContentLoaded', boot);
    }
  }
  if (document.getElementById('cart-drawer')) { boot(); }
  else { document.addEventListener('DOMContentLoaded', boot); }
})();